import { render, staticRenderFns } from "./CourseResourceCreate.vue?vue&type=template&id=b5c66d94&scoped=true&"
import script from "./CourseResourceCreate.vue?vue&type=script&lang=js&"
export * from "./CourseResourceCreate.vue?vue&type=script&lang=js&"
import style0 from "./CourseResourceCreate.vue?vue&type=style&index=0&id=b5c66d94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c66d94",
  null
  
)

export default component.exports